import $ from 'jquery';
import LZString from 'lz-string';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import SessionManager from '../../routes/SessionManager';
import Loading from '../Loading';
import { CSVLink } from "react-csv";
import Toastr from 'toastr';
import EulaDialog from './EulaDialog';
import DownloadReport from '../common/DownloadReport';
import { DatePicker } from "antd";
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

let zones = [];

function EnvironmentalReport(props) {

  let sessionMgr = new SessionManager();
  let user1 = sessionMgr.readCookie('user');

  const [user, setUser] = useState(user1);
  const [sdr_url, setSdrUrl] = useState('');
  const [locationChartData, setLocationChartData] = useState(null);
  const [sensorChartData, setSensorChartData] = useState({});
  const [date, setDate] = useState(props.pickedDate ? props.pickedDate : moment().format("YYYY-MM-DD"));
  const [csvData, setCsvData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [report_name, setReportName] = useState('');
  const [sensors_info, setSensorsInfo] = useState([]);
  const [sensorsList, setSensorsList] = useState([]);

  let chartPlugin = [];
  let isWeekly = props.title.indexOf('Daily') === -1;
  let zonesMap = {}
  let timezone = user.site_selected.site_iana_timezone;

  useEffect(() => {
    async function fetchData() {
      await fetchSiteLocationSensors();
    }

    for (var z of user.zones) {
      zones[z.location_id] = z;
      zonesMap[z.location_id] = z.location_name;
    }

    if (!timezone)
      timezone = moment.tz.guess();

    setUser(user);
    fetchData();

    let isEulaAccepted = user && user.user_config && user.user_config.eula
      && user.user_config.eula.env_report && user.user_config.eula.env_report === true;

    if (user.site_selected) {
      let site_info = user.site_selected.site_name + ' at ' + moment.tz(new Date(), timezone).format('MM-DD-YYYY hh:mm a');
      setReportName(props.title + ' [' + site_info + ']');
    }
    if (isEulaAccepted) {
      setLoading(true);
      fetchEnvironmentalReport();
    }
  }, [date])

  const fetchSiteLocationSensors = async () => {
    setLoading(true);
    return new Promise((resolve, reject) => {
      let data = {
        user_login: user.user_login,
        user_token: user.user_token,
        source: "D",
        criteria: {
          from: 0,
          size: 1000,
          sensor_site_id: user.site_selected.site_id
        }
      }

      CommonUtils.ajax(
        {
          url: API.COMMON_TABLE_OPERATIONS.REMOTE_SENSOR.FETCH,
          type: 'POST',
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(data)
        }
      ).then(
        (res) => {
          if (res && res.status && res.status.code === 200) {
            let data = res.data.records;
            setSensorsInfo(data,);
            resolve(data);
          }
        },
        (err) => {
          setSensorsInfo([]);
          resolve(data);

        }
      )
    })

  }

  const capitalize = (s) => {
    // if (typeof s !== 'string') return ''
    // return s.charAt(0).toUpperCase() + s.slice(1)

    return s.toUpperCase()
  }

  const fetchEnvironmentalReport = () => {

    var payload = {
      customer_id: user.customer_id,
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
      start_date: date ? (isWeekly ? moment(date, 'YYYY-MM-DD').add(-7, 'days').format('YYYY-MM-DD') : date) : moment().format('YYYY-MM-DD'),
      end_date: date ? date : moment().format('YYYY-MM-DD'),
      timezone: timezone
    }

    setDate(payload.end_date);
    setLoading(true);

    CommonUtils.ajax(
      {
        url: API.DATA.ENVIRONMENTAL,
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(payload)
      }
    ).then(
      (res) => {
        if (!res.status || res.status.code !== 200) {
          //retrying in a sec if any network issue
          setTimeout(() => {
            fetchEnvironmentalReport();
          }, 1000)
          return;
        }
        if (res.status && res.status.code === 200) {

          chartPlugin = [{
            afterDraw: (chart) => {
              let datasetSize = chart.data.datasets.length;
              if (datasetSize > 0) {

                let lastDataSet = chart.data.datasets[datasetSize - 1];
                // We might get with out no data dataset or one with empty data set.
                if (lastDataSet.label === 'NO DATA' && lastDataSet.noData) {
                  var ctx = chart.chart.ctx;
                  ctx.save();
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
                  ctx.font = "bold 14px sans-serif";
                  ctx.fillStyle = "rgba(0,0,0,1)";
                  ctx.fillText('No data available ...', chart.chart.width / 2, chart.chart.height / 2);
                  ctx.restore();
                }
              }
            }
          }];
          let sensor_info = [...sensors_info];
          let sList = [];
          for (let sensor of sensor_info) {
            let s = { ...sensor };
            s.sensor_name_key = s.sensor_type + "_" + s.sensor_id
            sList.push(s);
          }
          setSensorsList(sList);

          let csvData = [];

          let colors = ['#48C9B0', '#F5B041', '#3498DB', '#AF7AC5', '#21B345'];
          var envUnitsMap = {
            'temperature': 'F',
            'humidity': '%',
            'co': 'ppm',
            'co2': 'ppm',
            'voc': 'ppb',
            'leak': '',
            'flow': 'Gallons'
          };
          var data = res.data;
          setLoading(false);
          $('.datepicker').attr('readonly', 'true');

          var chartData = {};
          var sensors = ['temperature', 'humidity', 'CO', 'CO2', 'VOC'];
          var dates = [];

          if (data && data.length > 0) {
            var startDate = payload.start_date;
            while (startDate <= payload.end_date) {
              dates.push(moment(startDate, 'YYYY-MM-DD').format('MMM DD'));
              startDate = moment(startDate, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
            }
          }

          let locationwise_env_data = {};
          let sensorwise_env_data = {};

          //console.log(JSON.stringify(data))

          for (let d of data) {

            if (d.sensor_id === 'humidity' || d.sensor_id === 'temperature') {
              if (d.event_value && d.event_value === -100)
                d.event_value = null;
            }
            let sensorName = sList.find(s => s.sensor_name_key === d.sensor_name) && sList.find(s => s.sensor_name_key === d.sensor_name).sensor_name;
            var csvRec = {
              "Location Name": zonesMap[d.location_id],
              "Threshold Type": d.sensor_id,
              "Sensor Name": sensorName ? sensorName : capitalize(d.sensor_name),
              "Device Name": d.device_name,
              "Value": (d.sensor_id === 'humidity' && d.event_value >= 100 ? 99.9 : d.event_value) + envUnitsMap[d.sensor_id],
              "Date": moment.tz(d.sec_timestamp * 1000, timezone).format('YYYY-MM-DD HH:mm')
            };
            csvData.push(csvRec);

            if (d.sensor_name !== d.device_name)
              continue;

            if (d.sensor_id === 'co' || d.sensor_id === 'co2' || d.sensor_id === 'voc') {
              d.sensor_id = d.sensor_id.toUpperCase();
            }

            if (!locationwise_env_data[d.location_id])
              locationwise_env_data[d.location_id] = {};

            if (!locationwise_env_data[d.location_id][d.sensor_id]) {
              let dateMapDefaults = {};
              for (let dd of dates) {
                dateMapDefaults[dd] = [{ event_type: 'dummy', event_value: null, event_ts: dd + ', 00:00' }];
              }
              locationwise_env_data[d.location_id][d.sensor_id] = dateMapDefaults;
              //console.log(JSON.stringify(locationwise_env_data[d.location_id][d.sensor_id]));
            }

            //console.log(JSON.stringify(locationwise_env_data));
            var mmmdd = moment.tz(d.sec_timestamp * 1000, timezone).format('MMM DD');
            var hhmm = moment.tz(d.sec_timestamp * 1000, timezone).format('HH:mm')
            if (!locationwise_env_data[d.location_id][d.sensor_id][mmmdd]) {
              locationwise_env_data[d.location_id][d.sensor_id][mmmdd] = [];
            }

            var event_val = d.sensor_id === 'humidity' && d.event_value >= 100 ? 99.9 : d.event_value;
            locationwise_env_data[d.location_id][d.sensor_id][mmmdd].push({ event_value: Math.round(event_val, 2), event_ts: mmmdd + ', ' + hhmm });
          }

          for (let d of data) {
            if (d.sensor_id === 'voc')
              continue;

            if (d.sensor_name === d.device_name)
              continue;

            if (!sensorwise_env_data[d.sensor_name])
              sensorwise_env_data[d.sensor_name] = {};

            if (!sensorwise_env_data[d.sensor_name][d.sensor_id]) {
              let dateMapDefaults = {};
              for (let dd of dates) {
                dateMapDefaults[dd] = [{ event_type: 'dummy', event_value: null, event_ts: dd + ' 00:00' }];
              }
              sensorwise_env_data[d.sensor_name][d.sensor_id] = dateMapDefaults;
            }

            let mmmdd = moment.tz(d.sec_timestamp * 1000, timezone).format('MMM DD');
            let hhmm = moment.tz(d.sec_timestamp * 1000, timezone).format('HH:mm')
            if (!sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd]) {
              sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd] = [];
            }
            let event_val = d.sensor_id === 'humidity' && d.event_value >= 100 ? 99.9 : d.event_value;
            sensorwise_env_data[d.sensor_name][d.sensor_id][mmmdd].push({ event_loc: d.location_id, event_value: event_val, event_ts: mmmdd + ', ' + hhmm });
          }

          let sensorChartMap = {};
          let locationChartMap = {};

          for (let sensor_name_key in sensorwise_env_data) {
            let sensorwise_data = {};
            let locs_involved = {};
            let sensorIds = Object.keys(sensorwise_env_data[sensor_name_key]);
            let envParamsObj = {};

            for (let x of sensorIds) {
              envParamsObj[x] = null;
            }

            //console.log(JSON.stringify(sensorwise_env_data, null, 4))

            for (let sensor_id_key in sensorwise_env_data[sensor_name_key]) {
              for (let date_key in sensorwise_env_data[sensor_name_key][sensor_id_key]) {
                for (let date_key_rec of sensorwise_env_data[sensor_name_key][sensor_id_key][date_key]) {
                  if (date_key_rec.event_type === 'dummy' && sensorwise_env_data[sensor_name_key][sensor_id_key][date_key].length > 1) {
                    continue;
                  }
                  if (!sensorwise_data[date_key_rec.event_ts]) {
                    sensorwise_data[date_key_rec.event_ts] = JSON.parse(JSON.stringify(envParamsObj));
                  }
                  if (zonesMap[date_key_rec.event_loc])
                    locs_involved[zonesMap[date_key_rec.event_loc]] = null;
                  else
                    console.log('Zone Value not found for ' + date_key_rec.event_loc);
                  sensorwise_data[date_key_rec.event_ts][sensor_id_key] = date_key_rec.event_value;
                }
              }
            }

            //sensorChartData[sensor_name_key] = { locations: Object.keys(locs_involved), sensorData: sensorwise_data };

            let sensor_serial_number = sList.find((s) => s.sensor_name_key === sensor_name_key) && sList.find((s) => s.sensor_name_key === sensor_name_key).sensor_serial_number;

            sensorChartMap[sensor_name_key] = {
              options: {
                title: {
                  fontColor: 'rgba(0, 0, 0)',
                  display: true,
                  text: (sensor_serial_number ? sensor_serial_number : "sensor " + sensor_name_key) + " seeing by " + Object.keys(locs_involved).join(',')  //"Sensor " + sensor_name_key + " seeing by " +
                },
                legend: {
                  display: true
                },
                tooltips: {
                  mode: 'single',
                  intersect: false,
                  custom: function (tooltip) {
                    if (!tooltip) return;
                    tooltip.displayColors = false;
                  },
                  callbacks: {
                    title: function (tArr, d) {
                      if (tArr && tArr.length > 0) {
                        let t = tArr[0];
                        if (d.datasets[t.datasetIndex].label === 'NO DATA') {
                          return '';
                        } else {
                          let labelData = d.datasets[t.datasetIndex].labelData;
                          let val = t.yLabel + '' + labelData.units;
                          return labelData.label + '  ' + val;
                        }
                      }
                    },
                    label: function (t, d) {
                      if (d.datasets[t.datasetIndex].label === 'NO DATA') {
                        return 'No data found...';
                      } else {
                        return t.xLabel;
                      }
                    },
                    labelTextColor: function (t, chart) {
                      let isNoDataSet = this._data.datasets[t.datasetIndex].label === 'NO DATA';
                      return isNoDataSet ? '#FFFFFF' : colors[t.datasetIndex];
                    }
                  }
                },
                scales: {
                  xAxes: [{
                    categoryPercentage: 1.0,
                    barPercentage: 1.0,
                    ticks: {
                      autoSkip: true
                    },
                    display: true,
                    gridLines: {
                      display: true
                    },
                    scaleLabel: {
                      display: true,
                      labelString: 'Hour',
                      fontColor: 'orange'
                    }
                  }],
                  yAxes: []
                },
                maintainAspectRatio: false
              },

              labels: [],
              datasets: []
            };

            let labelsDateTimeSorted = Object.keys(sensorwise_data).sort((x, y) => { return moment(x, 'MMM DD, HH:mm').diff(moment(y, 'MMM DD, HH:mm'), 'hours', true) })
            sensorChartMap[sensor_name_key].labels = labelsDateTimeSorted;
            let envParamWiseData = JSON.parse(JSON.stringify(envParamsObj));

            let idx = 0;
            for (let envParam in envParamWiseData) {
              console.log('envParam', envParam);
              let yKey = sensor_name_key + '-' + envParam;
              sensorChartMap[sensor_name_key].options.scales.yAxes.push(
                {
                  display: true,
                  gridLines: {
                    display: false
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "",
                    fontColor: 'orange'
                  },
                  id: yKey,
                  position: idx > 0 ? 'right' : 'left',
                  ticks: {
                    fontColor: colors[idx]
                  },
                  beforeBuildTicks: function (e) {
                    e.options.display = (e.min !== -1);
                    //console.log(e.options);
                  }
                }
              );

              let envParamData = [];
              for (let date of sensorChartMap[sensor_name_key].labels) {
                envParamData.push(sensorwise_data[date][envParam]);
              }

              let minmax = filter_sort([...envParamData]);
              sensorChartMap[sensor_name_key].datasets.push(
                {
                  type: 'line',
                  labelData: { label: capitalize(envParam), min: minmax[0], max: minmax[minmax.length - 1], units: envUnitsMap[envParam] },
                  label: capitalize(envParam) + " (Min: " + minmax[0] + envUnitsMap[envParam] + ", Max: " + minmax[minmax.length - 1] + envUnitsMap[envParam] + ")",
                  backgroundColor: 'rgba(0,0,0,0)',
                  pointHoverBorderColor: colors[idx],
                  pointBackgroundColor: colors[idx],
                  borderColor: colors[idx],
                  hoverBackgroundColor: 'rgba(0,123,255,0.9)',
                  data: envParamData,
                  yAxisID: yKey,
                  pointRadius: 2
                }
              );
              idx++;

            }
            addNoDataDataSet(sensorChartMap[sensor_name_key]);
            //console.log(JSON.stringify(sensorChartMap[sensor_name_key]));
          }

          for (let loc_id_key in locationwise_env_data) {
            if (!chartData[loc_id_key]) {
              chartData[loc_id_key] = {}
            }
            let sensorwise_data = {};
            let sensorIds = Object.keys(locationwise_env_data[loc_id_key]);
            let envParamsObj = {};
            for (let x of sensorIds) {
              envParamsObj[x] = null;
            }

            for (let sensor_id_key in locationwise_env_data[loc_id_key]) {
              if (sensors.indexOf(sensor_id_key) === -1)
                continue;
              for (let date_key in locationwise_env_data[loc_id_key][sensor_id_key]) {
                for (let date_key_rec of locationwise_env_data[loc_id_key][sensor_id_key][date_key]) {
                  if (date_key_rec.event_type === 'dummy' && locationwise_env_data[loc_id_key][sensor_id_key][date_key].length > 1) {
                    continue;
                  }
                  if (!sensorwise_data[date_key_rec.event_ts]) {
                    sensorwise_data[date_key_rec.event_ts] = JSON.parse(JSON.stringify(envParamsObj));
                  }
                  //locs_involved[this.zonesMap[date_key_rec.event_loc]] = null;
                  sensorwise_data[date_key_rec.event_ts][sensor_id_key] = date_key_rec.event_value;
                }
              }
            }

            locationChartMap[loc_id_key] = {
              options: {
                title: {
                  fontColor: 'rgba(0, 0, 0)',
                  display: true,
                  text: zonesMap[loc_id_key]
                },
                legend: {
                  display: true
                },
                tooltips: {
                  mode: 'single',
                  intersect: false,
                  custom: function (tooltip) {
                    if (!tooltip) return;
                    tooltip.displayColors = false;
                  },
                  callbacks: {
                    title: function (tArr, d) {
                      if (tArr && tArr.length > 0) {
                        let t = tArr[0];
                        if (d.datasets[t.datasetIndex].label === 'NO DATA') {
                          return '';
                        } else {
                          let labelData = d.datasets[t.datasetIndex].labelData;
                          let val = t.yLabel + '' + labelData.units;
                          return labelData.label + '  ' + val;
                        }
                      }
                    },
                    label: function (t, d) {
                      if (d.datasets[t.datasetIndex].label === 'NO DATA') {
                        return 'No data found...';
                      } else {
                        return t.xLabel;
                      }
                    },
                    labelTextColor: function (t, chart) {
                      let isNoDataSet = data.datasets && data.datasets[t.datasetIndex] && data.datasets[t.datasetIndex].label === 'NO DATA';
                      return isNoDataSet ? '#FFFFFF' : colors[t.datasetIndex];
                    }
                  }
                },
                scales: {
                  xAxes: [{
                    categoryPercentage: 1.0,
                    barPercentage: 1.0,
                    ticks: {
                      autoSkip: true
                    },
                    display: true,
                    gridLines: {
                      display: true
                    },
                    scaleLabel: {
                      display: true,
                      labelString: 'Hour',
                      fontColor: 'orange'
                    }
                  }],
                  yAxes: []
                },
                maintainAspectRatio: false
              },

              labels: [],
              datasets: []
            };

            let labelsDateTimeSorted = Object.keys(sensorwise_data).sort((x, y) => { return moment(x, 'MMM DD, HH:mm').diff(moment(y, 'MMM DD, HH:mm'), 'hours', true) })
            locationChartMap[loc_id_key].labels = labelsDateTimeSorted;
            let envParamWiseData = JSON.parse(JSON.stringify(envParamsObj));
            let idx = 0;

            for (let envParam in envParamWiseData) {
              let yKey = loc_id_key + '-' + envParam;
              locationChartMap[loc_id_key].options.scales.yAxes.push(
                {
                  display: true,
                  gridLines: {
                    display: false
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "",
                    fontColor: 'orange'
                  },
                  id: yKey,
                  position: idx > 0 ? 'right' : 'left',
                  ticks: {
                    fontColor: colors[idx]
                  },
                  beforeBuildTicks: function (e) {
                    e.options.display = (e.min !== -1);
                    //console.log(e.options);
                  }
                }
              );
              let envParamData = [];
              for (let date of locationChartMap[loc_id_key].labels) {
                envParamData.push(sensorwise_data[date][envParam]);
              }

              let minmax = filter_sort([...envParamData]);
              locationChartMap[loc_id_key].datasets.push(
                {
                  type: 'line',
                  labelData: { label: capitalize(envParam), min: minmax[0], max: minmax[minmax.length - 1], units: envUnitsMap[envParam] },
                  label: capitalize(envParam) + " (Min: " + minmax[0] + envUnitsMap[envParam] + ", Max: " + minmax[minmax.length - 1] + envUnitsMap[envParam] + ")",
                  backgroundColor: 'rgba(0,0,0,0)',
                  pointHoverBorderColor: colors[idx],
                  pointBackgroundColor: colors[idx],
                  borderColor: colors[idx],
                  hoverBackgroundColor: 'rgba(0,123,255,0.9)',
                  data: envParamData,
                  yAxisID: yKey,
                  pointRadius: 2
                }
              );
              idx++;
            }
            addNoDataDataSet(locationChartMap[loc_id_key]);
          }
          ;
          setLocationChartData(locationChartMap);
          setSensorChartData(sensorChartMap);
          setCsvData(csvData);

          if (user.site_selected) {
            var minifiedUser = preparePDFData({ ...user });
            minifiedUser.date = payload.end_date;
            minifiedUser.weekly = payload.start_date !== payload.end_date;
            minifiedUser.is_today = true;

            let site_info = user.site_selected.site_name + "_" + Buffer.from(user.user_login).toString('base64') + '_' + minifiedUser.date;
            minifiedUser.save_report = true;
            minifiedUser.request_id = "Environmental " + (minifiedUser.weekly ? "Weekly" : "Daily") + " Report - " + site_info + ".pdf";

            setSdrUrl(API.getFullUrl('/pdf/environmental-report/Environmental ' + (minifiedUser.weekly ? 'Weekly' : 'Daily') + ' Report - ' + site_info + '.pdf?' + LZString.compressToBase64(JSON.stringify(minifiedUser)) + '=payload&host=' + window.location.host));
          }
        }

      },
      (res) => {
        setLoading(false);
        $('.datepicker').attr('readonly', 'true');
      });
  }

  const addNoDataDataSet = (chart) => {
    let dataSetsSize = chart.datasets.length;
    let maxVal = 0;
    let dataFoundPoints = 0;
    let missingData = chart.datasets[0].data.map((v, idx) => {
      let foundVal = false;
      for (let i = 0; i < dataSetsSize; i++) {
        if (chart.datasets[i].data[idx]) {
          if (chart.datasets[i].data[idx] > maxVal) {
            maxVal = chart.datasets[i].data[idx];
          }
          foundVal = true;
        }
      }
      if (foundVal)
        dataFoundPoints++;
      return foundVal ? 0 : 1;
    });

    if (maxVal === 0 && dataFoundPoints === 0) {
      maxVal = 100;
    }

    for (let i = 0; i < missingData.length; i++) {
      if (missingData[i] === 1)
        missingData[i] = maxVal;
    }

    let dataLen = missingData.length;
    if (dataFoundPoints !== dataLen) {
      console.log('Not found data for few ...');
      let yKey = new Date().getMilliseconds();
      let newDataSet = {
        noData: (dataFoundPoints === 0),
        type: 'bar',
        label: 'NO DATA',
        backgroundColor: '#dedede',
        borderColor: '#dedede',
        borderWidth: 0,
        hoverBackgroundColor: '#dedede',
        hoverBorderColor: '#dedede',
        data: missingData,
        yAxisID: yKey
      };
      console.log('Updating the chart ... newDataSet ', newDataSet);
      chart.datasets.push(newDataSet);
      let ticksObj = { display: false }
      if (dataFoundPoints === 0) {
        ticksObj = {
          display: false,
          beginAtZero: true,
          steps: 10,
          stepValue: 10,
          max: 100
        };
      }
      chart.options.scales.yAxes.push({
        display: true,
        gridLines: {
          display: false
        },
        scaleLabel: {
          display: true,
          labelString: "",
          fontColor: 'orange'
        },
        ticks: ticksObj,
        id: yKey,
        position: 'right',
        beforeBuildTicks: function (e) {
          e.options.display = (e.min !== -1);
        }
      });
    }
  }

  const filter_sort = (test_array) => {
    var index = -1,
      arr_length = test_array ? test_array.length : 0,
      resIndex = -1,
      result = [];

    while (++index < arr_length) {
      var value = test_array[index];

      if (value !== null) {
        result[++resIndex] = parseFloat(value);
      }
    }

    if (result.length > 0) {
      result = result.sort((a, b) => a - b);
    }

    return result.length === 0 ? ['-'] : result;
  }

  const preparePDFData = (userCopy) => {
    var pdfData = {};
    let flds = ["user_login", "user_token", "site_id", "customer_id"];
    for (let i = 0; i < flds.length; i++) {
      pdfData[flds[i]] = userCopy[flds[i]];
    }

    if (userCopy.site_selected) {
      pdfData.site_selected = {};
      let flds = ["site_id", "site_name", "site_iana_timezone", "site_city", "site_country"];
      for (let i = 0; i < flds.length; i++) {
        pdfData.site_selected[flds[i]] = userCopy.site_selected[flds[i]];
      }
    }

    if (userCopy.zone_selected) {
      pdfData.zone_selected = {};
      let flds = ["location_id"];
      for (let i = 0; i < flds.length; i++) {
        pdfData.zone_selected[flds[i]] = userCopy.zone_selected[flds[i]];
      }
    }

    if (userCopy.zones) {
      pdfData.zones = [];
      for (let z of userCopy.zones) {
        pdfData.zones.push({ location_name: z.location_name, location_id: z.location_id });
      }
    }
    return pdfData;
  }

  const onDateChange = (date) => {
    setDate(moment(new Date(date)).format('YYYY-MM-DD'));
  }

  const updateEULA = (event) => {
    $(event.target).attr("disabled", "disabled")
    $(event.target).find(".spinner").toggleClass("d-none");
    $(event.target).parent().find("input[type='checkbox']").attr("disabled", "disabled");
    var payload = {
      customer_id: user.customer_id,
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
      user_config: {
        'eula': {
          "env_report": true,
          "accepted_date": moment().format('YYYY-MM-DD HH:mm z')
        }
      }
    }

    CommonUtils.ajax(
      {
        url: API.USER.UPDATE_CONFIG,
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(payload)
      }
    ).then(
      (res) => {
        if (res && res.status && res.status.code === 200) {
          if (res.data && res.data.user_config) {
            var sessionMgr = new SessionManager();
            var user = sessionMgr.readCookie('user');
            user = { ...user, user_config: res.data.user_config };
            sessionMgr.storeCookie('user', user);
            setUser(user, () => {
              fetchEnvironmentalReport();
            });
            Toastr.success('User Configuration updated successfully', 'Status');
          }
        }
      }, err => {
        $(event.target).removeAttr("disabled");
        $(event.target).find(".spinner").toggleClass("d-none");
        $(event.target).parent().find("input[type='checkbox']").removeAttr("disabled");
        Toastr.error('An error occured ...please try again.', 'Error');
      });
  }

  const setPDFContentReady = () => {
    window.status = 'ready';
  }

  let isEulaAccepted = user && user.user_config && user.user_config.eula
    && user.user_config.eula.env_report && user.user_config.eula.env_report === true;
  if (!isEulaAccepted) {
    return <EulaDialog closeModal={props.closeModal} resizeModal={props.resizeModal} updateEULA={updateEULA} />;
  }

  var envData = locationChartData;

  return (
    <React.Fragment >
      <div className="modal-header p-2 bg-primary text-white">
        <span className="modal-title">{props.title}</span>
        <div>
          <button type='button' className='fa fa-expand' onClick={props.resizeModal}></button>
          <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={props.closeModal}></button>
        </div>
      </div>

      {!loading && (
        <div className="container px-2 bg-light" >
          <div className="row p-1">
            <div className="col-md-4 font-weight-bold text-primary pt-1 pl-4">
              {user && user.site_selected && user.site_selected.site_name}
            </div>
            <div className="col-md-8 text-right">
              {
                csvData && <button className="btn btn-white btn-sm mr-2">
                  <i className="far fa-file-excel text-success"></i>
                  <CSVLink className="text-decoration-none text-dark" filename={report_name + ".csv"} data={csvData}> Download CSV</CSVLink>
                </button>
              }
              <span className="mr-2"><DownloadReport report_url={sdr_url}></DownloadReport></span>
              {!props.hideDatePicker &&
                <DatePicker disabledDate={(current) => current > moment().endOf('day')} showToday={false} allowClear={false} inputReadOnly popupStyle={{ zIndex: 10000 }} onChange={onDateChange} defaultValue={moment(date, 'YYYY-MM-DD')} format={'YYYY-MM-DD'} />
              }
            </div>
          </div>
        </div>
      )}

      <div className="modal-body bg-white">
        <div className="p-1">
          {!loading &&
            <React.Fragment>
              {
                sensorChartData && Object.keys(sensorChartData).map((z, i) => {
                  let sensor_serial_number = sensorsList.length > 0 && sensorsList.find((s) => s.sensor_name_key === z);
                  sensor_serial_number = sensor_serial_number && sensor_serial_number.sensor_serial_number
                  return (
                    <React.Fragment key={i}>
                      <div className="card bg-shadow mb-3">
                        <div className="card-header bg-primary text-light p-2">{sensor_serial_number ? sensor_serial_number : z}</div>
                        <div className="card-body text-center">
                          <Bar
                            plugins={chartPlugin}
                            style={{ position: "relative" }}
                            data={sensorChartData[z]}
                            height={350}
                            options={sensorChartData[z].options}
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })
              }
              {
                locationChartData && Object.keys(zones).map((z, i) => (
                  <React.Fragment key={i}>
                    <div className="card bg-shadow mb-3">
                      <div className="card-header bg-primary text-light p-2">{zones[z]['location_name']}</div>
                      <div className="card-body text-center">
                        {
                          envData[zones[z]['location_id']] ?
                            <Bar
                              plugins={chartPlugin}
                              style={{ position: "relative" }}
                              data={envData[zones[z]['location_id']]}
                              height={350}
                              options={envData[zones[z]['location_id']].options}
                            />
                            : "No environmental data found ..."
                        }
                      </div>
                    </div>

                  </React.Fragment>
                ))

              }
              {setPDFContentReady()}
            </React.Fragment >
          }

          {
            loading && (<div><center><Loading> Loading ... </Loading></center></div>)
          }
        </div>
      </div>
      <div className="modal-footer bg-light" style={{ padding: '0.5rem 1rem' }}>

      </div>
    </React.Fragment >
  )
}

export default EnvironmentalReport;